export function isFinalEvent() {
	const target = new Date(2025, 10, 2, 10, 0, 0); // Mes 10 = noviembre (0-indexed)
	const now = new Date();
	return now >= target;
}

export function getApiURL() {
	const currentURL = window.location.hostname;
	if (currentURL === 'localhost' || currentURL === '127.0.0.1') {
		return 'http://localhost/mazda/backend/api';
	} else {
		return 'https://www.mazdaaccessorieschallenge.com/api';
	}
}

export const PHOTO_BASE_URL = 'https://www.mazdaaccessorieschallenge.com/prod_images/';